import Configs from '../configs';

const state = {
  localStore: true,
  notifications: [],
  stateVersion: Configs.VERSION.notifications
};

export default state;
